import { render, staticRenderFns } from "./ArticleViewIndex.vue?vue&type=template&id=1231456f&scoped=true"
import script from "./ArticleViewIndex.vue?vue&type=script&lang=js"
export * from "./ArticleViewIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1231456f",
  null
  
)

export default component.exports